import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { push } from 'react-router-redux';

import { loginRoutine } from '../../../redux/routines';

import styles from './styles';
import AuthService from '../../../utils/AuthService';

class Login extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
  };

  render() {
    //TODO display email verification message
    //this.props.location.search

    const { state } = this.props.location;

    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>
        {state && state.message ? <Paper style={styles.message}>{state.message}</Paper> : null}
        <div style={styles.buttons}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            style={styles.login}
            onClick={() => AuthService.login()}>Login</Button>
          <Button
            variant="contained"
            type="button"
            fullWidth
            style={styles.register}
            onClick={() => this.props.push('/register')}>Register</Button>
        </div>
      </div>

    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
    login: loginRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Authentication/Login/index.js